module.exports = __webpack_public_path__ + "static/media/dancers-blue.0610f249.png";